




























































































































import Vue from 'vue';
import Component from 'vue-class-component';
//@ts-ignore
import store from "../../store";
import {Player, UploadCardsResponse, UploadedCard, UploadedCardRequest} from "../../../types";
import UploadHelper from "../../helpers/UploadHelper";
import MessageHelper from "../../helpers/MessageHelper";
import Loader from "../Widgets/Loader.vue";
import EventApi from "../../api/EventsApi";
import PixiScene from "../../libs/table-hand/api/render/PixiScene";

@Component({
    components: {
        Loader
    },
    props: {
        uploadCardsUrl: {
            type: String,
            required: true,
        },
        dragFiles: {
            type: FileList,
            default: null
        },
        type: {
            type: String,
            required: true
        }
    }
})

export default class GameAddCardsFrom extends Vue {
    private imgPreviews: Array<{src: string, name: string}> = [];
    private backfacePreview: string = '';
    private hasInputValue: boolean = false;
    private formErrors: any = null;
    private isStack: boolean = false;
    private uploadCardsUrl!: string;
    private allowAddAsDeck: boolean = false;
    private emptyFields: boolean = false;
    private files: FileList|null = null;
    private loading: boolean = false;
    private loadingText:string = '';
    private dragFiles!: FileList;
    private type!: string;
    private filesArray: Array<File>|null = null;

    mounted(): void
    {
        if (this.dragFiles) {
            this.addFilesOnDrop(this.dragFiles);
        }
    }

    private submitForm(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.addCardToTable();
    }

    /**
     * Удалить картинку
     */
    private deleteImg(name: string): void
    {
        if (!this.filesArray) {
            return;
        }
        this.imgPreviews = this.imgPreviews.filter(item => item.name !== name);
        this.filesArray = this.filesArray.filter(file => file.name !== name);
    }

    /**
     * Удалить картинку
     */
    private deleteBackfaceImg(): void
    {
        this.backfacePreview = '';
        const backface = this.$refs.backfaceFile as HTMLInputElement;
        backface.value = '';
    }

    private toggleAsStack(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
    }

    /**
     * Добавить карту на стол
     * @private
     */
    private addCardToTable(): void
    {
        this.loading = false;
        const input = this.$refs.fileInputTable as HTMLInputElement;
        const backface = this.$refs.backfaceFile as HTMLInputElement;

        if (!input.files || !this.filesArray) {
            this.emptyFields = true;
            return;
        }

        this.files = input.files;
        let filesCount = this.filesArray.length;

        let data: UploadedCardRequest  = {
            cards: []
        };

        if (this.type === 'table') {
            data.is_stack = this.isStack;
            data.x = 0;
            data.y = 0;
        }

        let i = 0;

        //При массовой загрузке картинок файлы отправляются по одному
        //После сохранения всех картинок в storage на сервер отправляется массив карт
        let uploadCards = () => {
            if (!this.filesArray) {
                this.hideTaskForm();
                return;
            }

            this.loading = true;
            // @ts-ignore
            this.loadingText = `${this.$t('message.uploaded')} ${i} ${this.$t('message.of')} ${filesCount} ${this.$tc('message.images', filesCount)}`;

            let formData = new FormData();

            if (this.filesArray.hasOwnProperty(i)) {
                formData.append('files[]', this.filesArray[i]);
            }

            //При загрузке первого файла грузим рубашку, если она есть
            if (i === 0 && backface.files && backface.files[0]) {
                formData.append('backface', backface.files[0]);
            }

            UploadHelper.uploadCardRequest(formData, this.uploadCardsUrl).then((result: UploadCardsResponse) => {
                if (result.success && result.data.files) {

                    data.cards = data.cards.concat(result.data.files);

                    if (result.data.backface) {
                        data.backface = result.data.backface;
                    }

                    if (data.cards.length >= filesCount) {
                        this.hideTaskForm();
                        const pixiScene = window.PixiScene;
                        if (pixiScene && this.type === 'table') {
                            let pos = pixiScene.getSceneCenter();
                            data.x = pos.x - data.cards[0].width/2;
                            data.y = pos.y - data.cards[0].height/2;
                            MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_ADD_STACKS, data);
                        } else {
                            MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_ADD_CARD, data);
                        }
                        this.loading = false;
                    } else {
                        i++;
                        if (this.filesArray && this.filesArray.length) {
                            uploadCards();
                        }
                    }
                } else {
                    console.log('Не удалось загрузить файл');
                }
            }).catch(() => {
                console.warn('Ошибка загрузки файлов');
            });
        };

        uploadCards();
    }

    /**
     * Обработка изменений в полях формы
     */
    private onInput(e: any): void {
        const form = this.$refs.taskForm as HTMLFormElement;
        this.getFilePreview(e.target);
        this.filesArray = this.filesArray ?? [];
        this.filesArray.push(...e.target.files);
        //@ts-ignore
        this.hasInputValue = !!this.imgPreviews.length || form.elements.imageUrl.value;
    }

    /**
     * Обработка измнения в поле загрузки рубашки
     */
    private onInputBackface(e: any) : void
    {
        const input = e.target as HTMLInputElement;

        if (input.files) {
            const filesArray = Array.from(input.files);
            filesArray.forEach((file: File) => {
                this.backfacePreview = URL.createObjectURL(file);
            });
        }
    }

    /**
     * Создать изображение
     * @param src
     * @private
     */
    private createImage(src: string): Promise<HTMLImageElement>
    {
        const image = new Image();
        return new Promise((resolve, reject) => {
            image.onload = () => {
                resolve(image);
            };
            image.onerror = reject;
            image.src = src;
        });
    }

    /**
     * Получить превью изображения
     * @param input
     * @private
     */
    private getFilePreview(input: HTMLInputElement): void
    {
        if (input.files) {
            const filesArray = Array.from(input.files);
            filesArray.forEach((file: File) => {
                this.imgPreviews.push({src: URL.createObjectURL(file), name: file.name});
            });

        }

        if (this.imgPreviews.length > 1) {
            const promises: Array<Promise<HTMLImageElement | void>> = [];
            const sizes: Array<{[key: string]: number}> = [];

            this.imgPreviews.forEach(preview => {
                promises.push(
                    this.createImage(preview.src).then(result => {
                        sizes.push({width: result.naturalWidth, height: result.naturalHeight});
                    })
                );
            });

            Promise.all(promises).then(() => {
                for (let i = 1; i < sizes.length; i++) {
                    if (typeof sizes[0] !== 'undefined' && typeof sizes[i] !== 'undefined') {
                        if (sizes[0].width !== sizes[i].width || sizes[0].height !== sizes[i].height) {
                            this.allowAddAsDeck = false;
                            return;
                        }
                    }
                }

                this.allowAddAsDeck = true;
            });
        }
    }

    /**
     * Закрыть форму
     */
    private hideTaskForm() {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        const form = this.$refs.taskForm as HTMLFormElement;
        form.reset();
        this.imgPreviews = [];
        this.formErrors = null;
        //@ts-ignore
        for (let el of form.elements) {
            el.classList.remove('has-error');
        }
        this.$emit('hideTaskForm');
    }

    /**
     * Добавить файлы на дроп
     */
    private addFilesOnDrop(files: FileList): void
    {
        this.filesArray = this.filesArray ?? [];
        this.filesArray.push(...Array.from(files));
        const input = this.$refs.fileInputTable as HTMLInputElement;
        input.files = files;
        this.getFilePreview(input);
        this.hasInputValue = true;
    }

    /**
     * Добавить рубашку на дроп
     */
    private addBackfaceOnDrop(files: FileList): void
    {
        const input = this.$refs.backfaceFile as HTMLInputElement;
        input.files = files;
        if (input.files) {
            const filesArray = Array.from(input.files);
            filesArray.forEach((file: File) => {
                this.backfacePreview = URL.createObjectURL(file);
            });
        }
    }

    /**
     * Обработчик дропа в форму
     * @param e
     * @private
     */
    private dropImage(e: any): void
    {
        e.preventDefault();
        const files = e.dataTransfer.files;
        this.addFilesOnDrop(files);

    }

    /**
     * Обработчик дропа в форму
     * @param e
     * @private
     */
    private dropBackface(e: any): void
    {
        e.preventDefault();
        const files = e.dataTransfer.files;
        this.addBackfaceOnDrop(files);

    }
}
